import api from '../../services/api';
// const END_POINT = '/api';
import { SliderProjects } from '../../data';
const END_POINT = '/enduser';

const Registration = (data) => {
    return api.post('/UserInfo', data);
};

const getRCSliderData = () =>{
    return api.get('/resource-centers/latest');
} 
const getStatsData = () =>{
    return api.get('/resource-centers/stats');
} 
const getSliderProject = () => {

    return SliderProjects;
};
const GetLoginURL = () => {
    return api.get(`${END_POINT}/login`);
}

const verifyOtpRequest = (data) => {
    return api.post(`${END_POINT}/info`, data);
};

const logOut = () => {
    return api.post(`${END_POINT}/logout`, {}, { headers: { needsAuth: true } });
}

const refreshToken = (refreshToken) => {
    return api.post(`${END_POINT}/token/refresh`, {refresh_token: refreshToken});
}
export {
    Registration,
    getRCSliderData,
    getStatsData,
    getSliderProject,
    GetLoginURL,
    verifyOtpRequest,
    logOut,
    refreshToken
}